<svelte:options customElement={{ tag: "bt-modal", shadow: "none" }} />

<script lang="ts">
  import { modalStore } from '$shared/modal/modalStore';
  import ModalToggle from '$shared/modal-toggle/ModalToggle.svelte';
  import Icon from '$shared/icons/Icon.svelte';

  export let modalTitle = '';
  export let closeButtonText = 'Close';

  export let width: 'default' | 'medium' | 'wide' = 'default';
  export let showCloseIcon: boolean = false;
  export let showFooter: boolean = true;
  export let closeButtonClasses = '';


  $: modalName = $modalStore.modalName
</script>

{#if modalName}
  <div class="modal__outer">
    <ModalToggle closesModal modalToToggle={modalName} design="fullscreen"></ModalToggle>
    <div class="modal__inner {width}">
      {#if showCloseIcon}
        <div class="modal__title-row">
          <h2 class="modal__title">{modalTitle}</h2>
          <ModalToggle
            closesModal
            modalToToggle={modalName}
            design="action-button-text"
            buttonClasses={`modal__close-x ${closeButtonClasses}`}
          >
            <Icon icon="X2" size="medium" />
          </ModalToggle>
        </div>
      {:else}
        <h2 class="modal__title">{modalTitle}</h2>
      {/if}
        <slot name="modal-contents"></slot>
      {#if showFooter}
        <div class="modal-control-bar">
          <ModalToggle design="action-button-text" closesModal modalToToggle={modalName} buttonClasses="grow-0">
            {closeButtonText}
          </ModalToggle>
          <slot name="modal-control-bar"></slot>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style lang="postcss">
  :global(.modal-control-bar button[type="button"]) {
    flex-grow: 0;
  }
  .modal__outer {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 50;
    top: 0;
    left: 0;
  }
  .modal__inner {
    z-index: 50;
    position: absolute;
    max-width: calc(100vw - 8rem);
    background: white;
    padding: theme("padding.6");
    border-radius: theme("borderRadius.lg");
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
  .modal__inner.default {
    width: 500px;
  }
  .modal__inner.medium {
    width: 560px;
    box-shadow: theme("boxShadow.xl");
  }
  .modal__inner.wide {
    width: theme("screens.sm");
  }
  @media (max-width: theme("screens.sm")) {
    .modal__inner.default,
    .modal__inner.medium {
      max-width: calc(100vw - 2rem);
    }
    .modal__inner.medium {
      box-shadow: theme("btpShadow.main-shadow");
    }
    .modal__inner.medium .modal__title {
      font-size: theme("fontSize.base");
      font-weight: 500;
      line-height: 26px;
    }
    .modal__inner.wide {
      max-width: calc(100vw - 6rem);
    }
  }
  .modal-control-bar {
    display: flex;
    justify-content: flex-end;
    gap: .5rem;
  }
  .modal__title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: theme('spacing.4');
  }
  .modal__title {
    color: theme("colors.black");
    font-family: theme("fontFamily.sans");
    font-weight: 600;
    font-size: theme("fontSize.2xl");
    line-height: 30px;
    margin-bottom: theme("margin.4");
    margin-top: 0;
    .modal__title-row & {
      margin-bottom: theme("margin.6");
    }
  }
  :global(.modal__close-x) {
    position: absolute;
    top: theme("padding.6");
    right: theme("padding.6");
    width: theme('spacing.10');
    height: theme('spacing.10');
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    margin: 0;
  }
</style>